import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";
import SearchFields from "./searchFields";
import SearchTable from "./searchTable";
import "./style.scss";

import { searchSubmit } from "store/laborTable/actionCreator";
const LaborTable = () => {
  const { showTable } = useSelector((state) => state.laborTable);
  const { fcRole, district } = useSelector((state) => state.loggedInUser);
  const dispatch = useDispatch();
  useEffect(() => {
    if (fcRole && (fcRole == "FcDistrictMgr" || fcRole == "FcCityMgr")) {
      const payload = {
        district: fcRole == "FcDistrictMgr" && district ? [district] : [],
        storeNumber: [],
        laborCode: [],
        status: ["Pending"],
        accountNumber: [],
        jobNumber: [],
        parentNumber: "",
        priceType: [],
      };
      dispatch(searchSubmit(payload)).catch(() => toast.error("Error while fetching results, please try again."));
    }
  }, [dispatch, fcRole, district]);
  return (
    <React.Fragment>
      <SearchFields />
      {showTable && <SearchTable />}
    </React.Fragment>
  );
};

export default LaborTable;
